class MachineController {
  constructor() {
    this.selectedBrandValue = '';
    this.selectedModelValue = '';
    this.selectedBrandGid = '';
    this.selectedModelGid = '';
    this.filterAttributes = {
      brand: '',
      model: '',
    };
    this.maxRecentMachines = 3;
    this.machineSelectMethod = '';

    MachineController.instance = this;
    this.loadFromStorage();
    this.updateCollectionLinksOnPage();
  }

  static getInstance() {
    if (!MachineController.instance) MachineController.instance = new MachineController();
    return MachineController.instance;
  }

  loadFromStorage() {
    this.selectedBrandValue = localStorage.getItem('brand') || '';
    this.selectedModelValue = localStorage.getItem('model') || '';
    this.selectedBrandGid = localStorage.getItem('brandGid') || '';
    this.selectedModelGid = localStorage.getItem('modelGid') || '';
    this.machineSelectMethod = localStorage.getItem('machineSelectMethod') || '';
  }

  saveToStorage() {
    this.selectedBrandValue
      ? localStorage.setItem('brand', this.selectedBrandValue)
      : localStorage.removeItem('brand');
    this.selectedModelValue
      ? localStorage.setItem('model', this.selectedModelValue)
      : localStorage.removeItem('model');
    this.selectedBrandGid
      ? localStorage.setItem('brandGid', this.selectedBrandGid)
      : localStorage.removeItem('brandGid');
    this.selectedModelGid
      ? localStorage.setItem('modelGid', this.selectedModelGid)
      : localStorage.removeItem('modelGid');
    this.machineSelectMethod
      ? localStorage.setItem('machineSelectMethod', this.machineSelectMethod)
      : localStorage.removeItem('machineSelectMethod');
  }

  setFilterAttributes(brand, model) {
    this.filterAttributes = { brand, model };
  }

  setBrand(value, gid) {
    const oldValue = this.selectedBrandValue;
    this.selectedBrandValue = value;
    this.selectedBrandGid = gid || '';

    if (oldValue !== value) {
      this.selectedModelValue = '';
      this.selectedModelGid = '';
    }

    this.saveToStorage();
    this.publishChange();
    this.updateCollectionLinksOnPage();
  }

  setModel(value, gid) {
    this.selectedModelValue = value;
    this.selectedModelGid = gid || '';

    this.saveToStorage();
    this.publishChange();
    this.updateCollectionLinksOnPage();
  }

  setMachineSelectMethod(method) {
    this.machineSelectMethod = method;
    this.saveToStorage();
  }

  clearFilters() {
    this.selectedBrandValue = '';
    this.selectedModelValue = '';
    this.selectedBrandGid = '';
    this.selectedModelGid = '';
    this.saveToStorage();
    this.publishChange();
    this.updateCollectionLinksOnPage();
  }

  getCurrentState() {
    return {
      brand: this.selectedBrandValue,
      model: this.selectedModelValue,
      brandGid: this.selectedBrandGid,
      modelGid: this.selectedModelGid,
      machineSelectMethod: this.machineSelectMethod,
      isComplete: !!(this.selectedBrandValue || this.selectedModelValue),
      hasAnySelection: !!(this.selectedBrandValue || this.selectedModelValue),
    };
  }

  getFilterParams() {
    if (this.selectedModelGid) {
      return `filter.p.m.custom.models=${encodeURIComponent(this.selectedModelGid)}`;
    }

    return '';
  }

  getMetafieldFilterUrl(baseUrl) {
    if (!this.selectedModelGid) return baseUrl;

    const absoluteUrl = baseUrl.startsWith('http')
      ? baseUrl
      : `${window.location.origin}${baseUrl}`;
    const url = new URL(absoluteUrl);
    url.searchParams.set('filter.p.m.custom.models', this.selectedModelGid);
    return url.toString();
  }

  updateCollectionLinksOnPage() {
    const collectionLinks = document.querySelectorAll('a[href*="/collections/"]');

    collectionLinks.forEach((link) => {
      let originalHref = link.dataset.originalHref;

      if (!originalHref) {
        originalHref = link.href;
        link.dataset.originalHref = originalHref;
      }

      link.href = this.getMetafieldFilterUrl(originalHref);
    });
  }

  getRecentMachines() {
    try {
      const stored = localStorage.getItem('recentMachines');
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.warn('Failed to parse recent machines:', error);
      return [];
    }
  }

  addRecentMachine(brandValue, modelValue, yearValue, brandLabel, modelLabel, brandGid, modelGid) {
    if (!brandValue || !modelValue) return;

    const newMachine = {
      brand: brandValue,
      model: modelValue,
      brandLabel,
      modelLabel,
      brandGid: brandGid || '',
      modelGid: modelGid || '',
      timestamp: Date.now(),
    };

    let recentMachines = this.getRecentMachines();

    const existingIndex = recentMachines.findIndex(
      (machine) => machine.brand === brandValue && machine.model === modelValue
    );

    if (existingIndex !== -1) {
      recentMachines.splice(existingIndex, 1);
    }

    recentMachines.unshift(newMachine);
    recentMachines = recentMachines.slice(0, this.maxRecentMachines);

    try {
      localStorage.setItem('recentMachines', JSON.stringify(recentMachines));
      this.publishRecentMachinesChange();
    } catch (error) {
      console.warn('Failed to save recent machines:', error);
    }
  }

  selectRecentMachine(machine) {
    this.selectedBrandValue = machine.brand;
    this.selectedModelValue = machine.model;
    this.selectedBrandGid = machine.brandGid || '';
    this.selectedModelGid = machine.modelGid || '';
    this.saveToStorage();
    this.publishChange();
    this.updateCollectionLinksOnPage();
  }

  clearRecentMachines() {
    localStorage.removeItem('recentMachines');
    this.publishRecentMachinesChange();
  }

  publishChange() {
    const machineData = this.getCurrentState();
    publish('machine:change', machineData);
  }

  publishRecentMachinesChange() {
    const recentMachines = this.getRecentMachines();
    publish('machine:recent-change', recentMachines);
  }
}

window.MachineController = MachineController;
window.getMachineController = () => MachineController.getInstance();
